import PropTypes from 'prop-types';
import { Checkbox } from '../Checkbox/Checkbox';
import './DropdownOptions.scss';

export const DropdownOptions = (props) => {
  const { menuData, chosenValues, isMenuOpen, menuItemClickedHandler, extendClass = '' } = props;

  const menuOpenClass = isMenuOpen ? 'open' : '';
  const classes = ['options-list', extendClass, menuOpenClass].join(' ');

  const listItems = menuData.map((listItem) => {
    const { key, name } = listItem;
    const isChecked = chosenValues.includes(key);

    return (
      <li key={key} className="options-list__item" data-testid="options-item">
        <Checkbox
          checkboxChangeHandler={menuItemClickedHandler}
          label={name}
          value={key}
          isChecked={isChecked}
        />
      </li>
    );
  });

  return (
    <ul className={classes} data-testid="options-list">
      {listItems}
    </ul>
  );
};

DropdownOptions.propTypes = {
  menuData: PropTypes.array,
  chosenValues: PropTypes.array,
  isMenuOpen: PropTypes.bool,
  menuItemClickedHandler: PropTypes.func,
  extendClass: PropTypes.string,
};
